import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslatePipe } from '@ngx-translate/core';

export interface ErrorDialogData {
  error: HttpErrorResponse;
}

@Component({
    selector: 'fs-error-dialog',
    templateUrl: './error-dialog.component.html',
    imports: [MatDialogContent, TranslatePipe, MatDialogActions]
})
export class ErrorDialogComponent {
  data = inject<ErrorDialogData>(MAT_DIALOG_DATA);

  reload(): void {
    window.location.reload();
  }
}
